'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { ListPageTabs } from '@terra/ui-design-system';
import {
  ASSETS_VIEW,
  useTabScopedAssetsFilters,
  type AssetsView,
} from '../../../store/tab/assetsTabScopedFilterStore';

export const DEFAULT_ASSETS_VIEWS: readonly AssetsView[] = [
  ASSETS_VIEW.ENDPOINTS,
  ASSETS_VIEW.WEB_PAGES,
  ASSETS_VIEW.UNVERIFIED,
];

export function AssetsViewTabs({ views }: { views: readonly AssetsView[] }) {
  const t = useTranslations('proxy.assets.views');
  const { view, setView } = useTabScopedAssetsFilters();
  const options = useMemo(
    () =>
      views.map((assetsView) => ({
        value: assetsView,
        label: t(assetsView),
      })),
    [t, views],
  );

  return (
    <ListPageTabs options={options} value={view} onValueChange={setView} />
  );
}
